const handleUpgrade = () => window.open('https://www.dponet.com.br', '_blank')

export default handleUpgrade
